import { render, staticRenderFns } from "./EtiquetasModalEdicion.vue?vue&type=template&id=66936fad&scoped=true&"
import script from "./EtiquetasModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./EtiquetasModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./EtiquetasModalEdicion.vue?vue&type=style&index=0&id=66936fad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66936fad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('66936fad', component.options)
    } else {
      api.reload('66936fad', component.options)
    }
    module.hot.accept("./EtiquetasModalEdicion.vue?vue&type=template&id=66936fad&scoped=true&", function () {
      api.rerender('66936fad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/EtiquetasModalEdicion.vue"
export default component.exports